export default __webpack_public_path__ + "static/media/Brad-Wearne-Meridian-297x300.b46b91ac.jpg";